import React, { useEffect } from 'react';

import {
  Flex, Stack, Text, useToast,
} from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { updatePassword } from 'api/auth';
import { Input, Button, Checkbox } from 'components';
import useUser from 'stores/useUser';
import newPassword from 'validations/newPassword';

export default function NewPassword() {
  const { accessCode, user, set } = useUser();
  const { push } = useHistory();
  const toast = useToast();
  const form = useForm({
    mode: 'all',
    resolver: newPassword,
  });
  const {
    register, handleSubmit, watch, setError, setValue, formState: { dirtyFields },
  } = form;

  useEffect(() => {
    register('accessCode');
    setValue('accessCode', accessCode);
  }, [accessCode]);

  const { mutate, isLoading } = useMutation(updatePassword, {
    onSuccess: ({ data, headers }) => {
      set({ accessCode: null, user: data, token: headers.token });
      push('/profile');
    },
    onError: (error: any) => {
      if (error.errors) {
        error.errors.forEach((err) => {
          if (err.field) {
            setError(err.field, err);
          } else {
            setError(Object.keys(dirtyFields)[0], err);
          }
        });
      } else {
        toast({
          title: 'Ocorreu um erro.',
          description: error.message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        });
      }
    },
  });

  const onSubmit = (data) => {
    mutate({
      id: user.id,
      data: {
        ...data,
        currentPassword: accessCode,
      },
    });
  };

  return (
    <Stack
      width="100%"
      alignItems="center">
      <Text
        variant="2xLargeSemiBold"
        color="secondary.default">
        Nova Senha
      </Text>
      <Text
        textAlign="center"
        variant="mediumRegular">
        Defina uma senha para a sua conta:
      </Text>
      <FormProvider {...form}>
        <Flex
          onSubmit={handleSubmit(onSubmit)}
          pt={6}
          width="100%"
          flexDir="column"
          as="form"
          justifyContent="space-between"
          flex={1}>
          <Stack
            pb={6}
            spacing={5}>
            <Input
              isSecure
              label="Nova senha"
              {...register('password')}
            />
            <Input
              isSecure
              label="Confirmar senha"
              {...register('passwordConfirmation')}
            />
            <Checkbox
              {...register('legalAgreement')}
              fontVariant="smallrRegular">
              Eu li e concordo com os
              <Text
                as="a"
                variant="smallBold"
                target="_blank"
                href={process.env.REACT_APP_TERMS_AND_CONDITIONS_URL}
                rel="noreferrer">
                {' '}Termos e Condições{' '}
              </Text>
              e a
              <Text
                as="a"
                variant="smallBold"
                target="_blank"
                href={process.env.REACT_APP_TERMS_AND_CONDITIONS_URL}
                rel="noreferrer">
                {' '}Política de Privacidade{' '}
              </Text>
              da Plataforma BioControl.
            </Checkbox>
          </Stack>
          <Button
            isLoading={isLoading}
            disabled={!watch('legalAgreement')}
            type="submit"
            size="xs"
            variant="primary.blue">
            <Text variant="smallBold">
              Concluir
            </Text>
          </Button>
        </Flex>
      </FormProvider>
    </Stack>
  );
}
